import React from "react";
import { sendToUrl } from "../../../utilities";

export default function BestSchemes({ data }) {
  return (
    <div className="howToInvestWrapper">
      <h3 className="heading-1-bold tableTitle">{data.heading}</h3>
      {data.scheme.map((scheme, id) => (
        <div className="d-f-c" key={id} style={{ marginTop: "18px" }}>
          <div>
            <div className="para-3 ">
              <a
                href={sendToUrl(scheme.url)}
                className="heading-3-bold"
                style={{ textDecorationLine: "underline" }}
                rel="noopener noreferrer"
              >
                {id + 1}. {scheme.heading}
              </a>
            </div>
            {scheme.fund_meta.map((meta, index) => (
              <div className="metaDataContainer" key={index}>
                <span className="para-3 spacer_sm">
                  {meta.title}:{" "}
                </span>
                <span className="para-3-bold spacer_sm">
                  {meta.val}
                </span>
              </div>
            ))}
            <div
              style={{ minHeight: "0.01%", overflowX: "auto" }}
            >
              <table style={{ width: "100%" }} cellspacing="0px">
                <tbody>
                  <tr>
                    {["RETURNS", "1 YEARS", "3 YEARS", "5 YEARS"].map((item, id) =>
                      (<th className={`para-4 tableColName ${id === 3 ? "text-right" : "text-left"} ${id === 0 || id === 3 ? "" : "optional"}`}> {item} </th>))}
                  </tr>
                  {scheme.table_data.map((tableRow, key) => (
                    <tr key={key}>
                      <td className="para-2-bold bold tableRowHead">
                        {tableRow["title"]}
                      </td>
                      <td className="para-2 optional">
                        {tableRow["yoy_return"]}
                      </td>
                      <td className="para-2 optional">
                        {tableRow["return_3yr"]}
                      </td>
                      <td
                        className="para-2"
                        align="right"
                      >
                        {tableRow["return_5yr"]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="objectiveWrapper">
              <h4 className="heading-3-bold title">Objective</h4>
              <p className="para-2 text">{scheme.objective}</p>
            </div>
            <div className="objectiveWrapper">
              <h4 className="heading-3-bold title">Suitability</h4>
              <p className="para-2 text">
                This product is suitable for investors who are seeking:
              </p>
              {scheme.suitability.suitability_reason.map((reason, id) => (
                <li key={id} className="para-2 points">
                  {reason}
                </li>
              ))}
              <br />
              <p className="para-2 text">
                {scheme.suitability.desc}
              </p>
            </div>
          </div>
        </div>
      ))}
      <style jsx>{`
      .howToInvestWrapper{
        margin-bottom: 24px;
        padding-bottom: 32px;
      }
      @media (max-width: 768px) {
        .howToInvestWrapper {
          padding-bottom: 0;
        }
        .optional{
          display:none;
        }
       
      }
      .tableTitle{
        text-decoration:none;
        margin:50px 0 16px;
      }
      .schemeName{
        margin-bottom:16px;
      }
      .metaDataContainer{
        margin:12px 0;
      }.tableColName{
        margin-bottom:16px;
      }.objectiveWrapper{
        margin:24px 0;
      }.title{
        margin-top:24px;
      }.text{
        margin-bottom: 16px;
      }.points{
        margin-bottom:4px;
      }

      `}</style>
    </div>
  );
}
